import * as Yup from "yup";

const mdfeUpdateValidator = Yup.object().shape({
  fatVeiculoId: Yup.string().required("Veiculo"),
  proprietarioVeiculoCpfCnpj: Yup.string().nullable(),
  proprietarioVeiculoUf: Yup.string().nullable(),
  proprietarioVeiculoNome: Yup.string().nullable(),
});

export default mdfeUpdateValidator;
